

<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form>
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input placeholder="Search Concern Type  Here..." class="w-full border p-2 rounded-md outline-none"
          placeholder="Search User" matInput (input)="applyFilter($event)" />
      </div>
      <div class="w-80">
        <select style="background: #4d4de6"
          class="w-full p-2 outline-none bg-gradient-to-r from-primary to-semiPrimary border rounded-md text-white"
          (change)="filterByStatus($event)">
          <option value="">{{ "all" | translate }}</option>
          <option value="Pending">{{ "pending" | translate }}</option>
          <option value="Verified">{{ "verified" | translate }}</option>
          <option value="Rejected">{{ "rejected" | translate }}</option>
        </select>
      </div>

      <div class="w-60">
        <app-primary-button [routerLink]="'/home/b1'" class="flex w-60">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>{{ "B1" | translate }}</span>
          </div>
        </app-primary-button>
      </div>
    
    </div>
  </form>
    <div class="bg-white rounded-2xl shadow-md p-4">
      <div class="overflow-auto">
           <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 w-full">

    <ng-container matColumnDef="clientName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Name</th>
      <td mat-cell *matCellDef="let element">{{ element.clientName }}</td>
    </ng-container>

    <ng-container matColumnDef="contactPerson">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact Person</th>
      <td mat-cell *matCellDef="let element">{{ element.contactPerson }}</td>
    </ng-container>

    <ng-container matColumnDef="district">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>District</th>
      <td mat-cell *matCellDef="let element">{{ element.district }}</td>
    </ng-container>

    <ng-container matColumnDef="tehsil">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Tehsil</th>
      <td mat-cell *matCellDef="let element">{{ element.tehsil }}</td>
    </ng-container>

    <ng-container matColumnDef="village">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Village</th>
      <td mat-cell *matCellDef="let element">{{ element.village }}</td>
    </ng-container>

    <ng-container matColumnDef="area">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Area</th>
      <td mat-cell *matCellDef="let element">{{ element.area }}</td>
    </ng-container>

    <ng-container matColumnDef="entryDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Entry Date</th>
      <td mat-cell *matCellDef="let element">{{ element.entryDate }}</td>
    </ng-container>

    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
      <td mat-cell *matCellDef="let element">{{ element.category }}</td>
    </ng-container>

    <ng-container matColumnDef="mineral">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Mineral</th>
      <td mat-cell *matCellDef="let element">{{ element.mineral }}</td>
    </ng-container>

    <ng-container matColumnDef="fileStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>File Status</th>
      <td mat-cell *matCellDef="let element">{{ element.fileStatus }}</td>
    </ng-container>

    <ng-container matColumnDef="torOnlineDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>TOR Date</th>
      <td mat-cell *matCellDef="let element">{{ element.torOnlineDate }}</td>
    </ng-container>

    <ng-container matColumnDef="proposalNo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Proposal No</th>
      <td mat-cell *matCellDef="let element">{{ element.proposalNo }}</td>
    </ng-container>

    <ng-container matColumnDef="caseNo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Case No</th>
      <td mat-cell *matCellDef="let element">{{ element.caseNo }}</td>
    </ng-container>

    <ng-container matColumnDef="pptStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>PPT Status</th>
      <td mat-cell *matCellDef="let element">{{ element.pptStatus }}</td>
    </ng-container>

    <ng-container matColumnDef="seiaaMinutes">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>SEIAA Minutes</th>
      <td mat-cell *matCellDef="let element">{{ element.seiaaMinutes }}</td>
    </ng-container>

    <ng-container matColumnDef="ecStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>EC Status</th>
      <td mat-cell *matCellDef="let element">{{ element.ecStatus }}</td>
    </ng-container>

    <ng-container matColumnDef="nextFollowUp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Next Follow-Up</th>
      <td mat-cell *matCellDef="let element">{{ element.nextFollowUp }}</td>
    </ng-container>
     <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>{{ "action" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="primary" [routerLink]="['/home/docoment-list']">
            <mat-icon>description</mat-icon>
          </button>
     
        </td>
      </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

      </div>
     
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

    </div>